import { Injectable } from '@angular/core';
import * as io from 'socket.io-client'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket : any;
  // readonly url : string = 'http://203.154.250.220:3001'
  // readonly url : string = 'http://172.16.113.72:5002'
  readonly url : string = 'https://socket.manageai.co.th'

  constructor() {
    this.socket = io(this.url)
   }

   listen(eventName : string){
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data)
      })
    });
  }

  emit(eventName: string, data: any){
    this.socket.emit(eventName, data)
  }

  login_socket(eventName : string){
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data)
      })
    });
  }

  data_post(eventName : string){
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data)
      })
    });
  }

  data_queue(eventName : string){
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data)
      })
    });
  }
}
